import InnerComponent from '@Components/Inventory/Indent';
import orgContainer from '@Components/AppContainer';

const Indent = () => ((orgContainer(InnerComponent)));
export default Indent;
